/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AreasIcon from 'icons/AreasIcon';

const messages = defineMessages({
  title: {id: 'navigation.educator-merit-pay.effectiveness-areas'},
});

const EffectivenessAreasItem = () => (
  <RouteLinkItem
    iconBefore={AreasIcon}
    route="midas/educator-merit-pay/effectiveness-areas"
    title={messages.title}
  />
);

export default EffectivenessAreasItem;
